import React from 'react';

import { Typography, Box } from '@material-ui/core';
import { StyledContainer, Iniciar } from './styles';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import disque from '../../assets/images/disque.png';

//assets
import btn_iniciar from '../../assets/buttons/btn_iniciar_transparente.svg';

export default function () {
  return (
    <StyledContainer>
      <Header nohome />
      <Box id='container'>
        <Box className='disque'>
          <img src={disque} alt='disque saúde 136' />
        </Box>
        <Box id='texts'>
          <Box className='wrapper'>
            <Box id='title'>
              <Typography variant='h3'>
                Reabilitação nas principais alterações <br /> neurofuncionais de pacientes com condições pós-covid.
              </Typography>
              {/* <Typography variant='body1'>
                Caso necessário, este aqui é o possível subtítulo do infográfico
              </Typography> */}
            </Box>
            <Box id='button'>
              <Iniciar to='/p2'>
                <img src={btn_iniciar} alt='Vamos começar?' />
              </Iniciar>
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer color='rgba(0, 0, 0, 0)' logos />
    </StyledContainer>
  );
}
